import { createSelector } from 'reselect';
const getResourcesLookupState = (state) => state.domain.resourcesLookup;
export const getResourceLookupResources = createSelector([getResourcesLookupState], (resourcesState) => {
    return resourcesState.resources.listOfResources;
});
export const getResourceLookupIsResourcesLoading = createSelector([getResourcesLookupState], (resourcesState) => {
    return resourcesState.resources.isListOfResourcesLoading;
});
export const getResourceLookupIsFetchResourcesSuccess = createSelector([getResourcesLookupState], (resourcesState) => {
    return resourcesState.resources.isListOfResourcesLoadingSuccess;
});
export const getResourceLookupIsFetchResourcesFailure = createSelector([getResourcesLookupState], (resourcesState) => {
    return resourcesState.resources.isListOfResourcesLoadingFailed;
});
export const getResourceLookupIsReassignInProgress = createSelector([getResourcesLookupState], (resourcesState) => {
    return resourcesState.resources.isReassignInProgress;
});
export const getResourceLookupIsReassignSuccessful = createSelector([getResourcesLookupState], (resourcesState) => {
    return resourcesState.resources.didReassignSuccess;
});
export const getResourceLookupIsReassignFailure = createSelector([getResourcesLookupState], (resourcesState) => {
    return resourcesState.resources.didReassignFail;
});
export const getResourceLookupUpdatedJobDate = createSelector([getResourcesLookupState], (resourcesState) => {
    return resourcesState.resources.updatedJobDate;
});
//# sourceMappingURL=getResourcesLookupStateData.js.map